const MAX_ITEMS = 3;
// We may want to remove these tokens and allow
// <ThumbnailStack /> to take the size of its parent.
// That way, the consumer can render this at any size.
const ITEM_SIZE_TOP = 60;
const ITEM_OFFSET = 4;

export const tokens = {
    zindex: {
        present: 1,
        leaving: 2,
        item: {
            top: 6,
            middle: 5,
            bottom: 4,
            base: 3,
        },
    },
    list: {
        maxItems: MAX_ITEMS,
        width: ITEM_OFFSET * (MAX_ITEMS - 1) + ITEM_SIZE_TOP,
        height: ITEM_SIZE_TOP,
    },
    item: {
        size: {
            top: ITEM_SIZE_TOP,
            middle: ITEM_SIZE_TOP - ITEM_OFFSET,
            bottom: ITEM_SIZE_TOP - ITEM_OFFSET * 2,
        },
        shadowSize: {
            top: ITEM_OFFSET,
            middle: ITEM_OFFSET - 1,
            bottom: ITEM_OFFSET - 2,
        },
        radius: 8,
        offset: ITEM_OFFSET,
    },
};
